import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { getCurrentUser } from 'aws-amplify/auth';
import { cognitoConfig } from './config/cognito';
import Login from './components/Login';
import Signup from './components/Signup';
import ChatLayout from './components/ChatLayout';
import LifeAnalysisPage from './components/LifeAnalysisPage';
import TermsPage from './components/TermsPage';
import LandingPage from './components/marketing/LandingPage';
import PricingPage from './components/marketing/PricingPage';
import AboutPage from './components/marketing/AboutPage';
import ProductPage from './components/marketing/ProductPage';
import BlogPage from './components/marketing/BlogPage';
import BlogPostPage from './components/marketing/BlogPostPage';
import ScrollToHash from './components/marketing/ScrollToHash';

Amplify.configure(cognitoConfig);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      await getCurrentUser();
      setIsAuthenticated(true);
    } catch {
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontFamily: 'Sora, sans-serif',
          color: '#5a6b7d',
          background: '#f7fafc'
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <Router>
      <ScrollToHash />
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <ChatLayout onLogout={() => setIsAuthenticated(false)} />
            ) : (
              <LandingPage />
            )
          }
        />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route
          path="/login"
          element={
            !isAuthenticated ? (
              <Login onLogin={() => setIsAuthenticated(true)} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/signup"
          element={
            !isAuthenticated ? (
              <Signup onLogin={() => setIsAuthenticated(true)} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="/terms" element={<TermsPage />} />
        <Route
          path="/analysis"
          element={isAuthenticated ? <LifeAnalysisPage /> : <Navigate to="/login" />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
